module.exports = __webpack_public_path__ + "static/cover-tech.0d03c095.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cover-tech.jpg
// module id = 548
// module chunks = 226651268387883